import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import './latest-news-widget.m.css';

const LatestNewsWidget = (props) => {
  const [allStories, setAllStories] = useState([]);

  useEffect(() => {
    if (allStories?.length === 0) {
      (async () => {
        const storyId = props.story.id;
        const response = await (
          await fetch(
            `/api/v1/search?sort=latest-published&limit=5&fields=headline,subheadline,published-at,summary,hero-image-s3-key,hero-image-caption,hero-image-metadata,author-name,author-id,slug,url,id,published-at,updated-at,alternative,access-level-value`
          )
        ).json();
        if (isMobile) {
          setAllStories(response?.['results']?.['stories']?.slice(1));
        } else {
          setAllStories(response?.['results']?.['stories']);
        }
      })();
    }
  }, []);

  return (
    <React.Fragment>
      {allStories?.length > 0 && (
        <div styleName="latest-wrapper">
          <div styleName="heading-wrapper">
            <h4 styleName="heading">
              <img
                width="20px"
                height="20px"
                alt="dice"
                styleName="dice-img"
                src="https://images.assettype.com/bloombergquint/2022-05/6cf7dbaf-011a-4040-9825-744af7d9e97f/ic_dice.png"
              />
              LATEST NEWS
            </h4>
          </div>
          <div styleName="section-wrapper">
            <div styleName="story">
              {allStories.map((story, index) => (
                <a href={`/${story?.slug}`} key={index} styleName="item">
                  <div styleName="thumbnail">
                    <img
                      styleName="thumbnail-img"
                      src={'https://gumlet.assettype.com/' + story['hero-image-s3-key']}
                      alt={story?.headline}
                    />
                  </div>
                  <div styleName="text">
                    <h5 styleName="text-heading">{story?.headline}</h5>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default LatestNewsWidget;
